export const limitString = (str, limit) => {
  return str?.length > limit ? str?.slice(0, limit) + "..." : str;
};

export const getSource = (org_id) => {
  if (org_id === 1) {
    // return "aelia_auckland";
    return "aelia_auckland";
  } else if (org_id === 2) {
    // return "aelia_adelaide";
    return "aelia_queenstown";
  }
};

/** Lagardere Travel Retail — analytics/duty-free sites only */
export const LAGARDERE_DUTY_FREE_LOCATIONS = [
  "aelia_auckland",
  "lotte_melbourne",
  "heinemann_sydney",
  "ishopchangi",
];

/** Lagardere Travel Retail — duty-free allowlist + NZ domestic sites */
const LAGARDERE_ALLOWED_LOCATIONS = new Set([
  ...LAGARDERE_DUTY_FREE_LOCATIONS,
  // NZ domestic
  "beauty_bliss",
  "big_barrel",
  "chemist_warehouse",
  "farmers",
  "lifepharmacy",
  "liquorland",
  "mecca",
  "nz_liquor",
  "nz_themall",
  "sephora",
  "whisky_and_more",
]);

const LAGARDERE_ANALYTICS_LOCATIONS = new Set(LAGARDERE_DUTY_FREE_LOCATIONS);

/**
 * @param {Array} locations - Array of location strings (website keys)
 * @param {number|null} organizationId - Organization ID
 * @returns {Array} Filtered locations array
 */
export const filterLocationsByOrg = (locations, organizationId) => {
  if (!Array.isArray(locations)) return locations;

  // org 3 = Lagardere: Auck/Mel/Syd/Changi + NZ domestics
  if (organizationId === 3) {
    return locations.filter((location) =>
      LAGARDERE_ALLOWED_LOCATIONS.has(location)
    );
  }

  return locations;
};

/**
 * Analytics page site filter for Lagardere — Auckland, Melbourne, Sydney, Changi only.
 * @param {Array} locations
 * @param {number|null} organizationId
 * @returns {Array}
 */
export const filterAnalyticsLocationsByOrg = (locations, organizationId) => {
  if (!Array.isArray(locations)) return locations;

  if (organizationId === 3) {
    return locations.filter((location) =>
      LAGARDERE_ANALYTICS_LOCATIONS.has(location)
    );
  }

  return locations;
};
